var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup47216(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 104,
    viewBox: "0 0 101 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_33_607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7813 84.0147C73.0438 105.967 41.6716 110.256 19.7194 93.5189C-2.23278 76.7814 -6.52227 45.4092 10.2152 23.457C26.9527 1.50486 69.5954 -7.24235 86.0806 6.80367C101.304 19.9245 106.519 62.0626 89.7813 84.0147Z",
    fill: "#FFA2E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33_607",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 104
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.7813 84.0147C73.0438 105.967 41.6716 110.256 19.7194 93.5189C-2.23278 76.7814 -6.52227 45.4092 10.2152 23.457C26.9527 1.50486 69.5954 -7.24235 86.0806 6.80367C101.304 19.9245 106.519 62.0626 89.7813 84.0147Z",
    fill: "#FE94DD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33_607)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_33_607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5115 -6.59192C90.2923 11.1351 46.2946 4.35636 24.8686 28.2646C3.44264 52.1729 12.702 97.7145 -7.07878 79.9875C-26.8595 62.2605 -25.5258 28.5084 -4.09988 4.60018C17.3261 -19.3081 50.7307 -24.3189 70.5115 -6.59192Z",
    fill: "#FFFCED"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_33_607",
    x: -9.36289,
    y: -7.02217,
    width: 109.508,
    height: 110.756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -9.36289,
    dy: -7.02217
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.874
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_33_607"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_33_607",
    x: -57.3473,
    y: -53.46,
    width: 169.11,
    height: 173.71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1316,
    result: "effect1_foregroundBlur_33_607"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup47216);
export default __webpack_public_path__ + "static/media/Group 47216.34e82aeaff05c07f977a5b69ec0a4e12.svg";
export { ForwardRef as ReactComponent };